import { createAudioService } from './createAudioService';
import type { AudioService } from './AudioService';

let instance: AudioService | null = null;

/** Process-wide audio singleton (presentation calls this; tests get no-op). */
export function getAudioService(): AudioService {
  if (instance == null) {
    instance = createAudioService();
  }
  return instance;
}

/** Test helper — reset singleton between suites. */
export function resetAudioServiceForTests(): void {
  instance?.dispose();
  instance = null;
}

export type {
  AudioService,
  AudioPlayOptions,
  AudioLoadCatalogOptions,
} from './AudioService';
export { createAudioService } from './createAudioService';
